var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusicCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM9.71428 7.5431V11.334C9.46213 11.2124 9.16938 11.1429 8.85714 11.1429C7.91036 11.1429 7.14285 11.7825 7.14285 12.5714C7.14285 13.3604 7.91036 14 8.85714 14C9.80391 14 10.5714 13.3604 10.5714 12.5714V9.34086C10.5714 9.22176 10.6453 9.11515 10.7568 9.07333L12.4864 8.42476C12.7094 8.34112 12.8571 8.12791 12.8571 7.88971V6.81583C12.8571 6.41928 12.4631 6.14329 12.0904 6.2788L10.0904 7.00608C9.86461 7.08819 9.71428 7.30281 9.71428 7.5431Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicCircle);
export default __webpack_public_path__ + "static/media/music-circle.ef48aa25d97bd8e404f0ca86b7f2f38b.svg";
export { ForwardRef as ReactComponent };